export enum ProfileTabs {
  Main = "Main",
  Connections = "Connections",
  Raffles = "Raffles",
  Shop = "Points Shop",
  Bets = "Bets History",
  Transactions = "Transactions",
  Boxes = 'Opened Box'
}

export const ProfileTabsListPublic = [
  ProfileTabs.Main,
  ProfileTabs.Connections,
  ProfileTabs.Raffles,
  ProfileTabs.Shop,
  ProfileTabs.Bets,
  ProfileTabs.Boxes,
];

export const ProfileTabsListRestricted = [...ProfileTabsListPublic, ProfileTabs.Transactions];
